// MIT License - Copyright (c) 2026 Doug McNall

export const DCAliensPlanets = {
  planets: {
    1400: ['superman', 'batman', 'wonderwoman', 'flash', 'greenlantern', 'aquaman'],
    1401: ['superman', 'lexluthor', 'loislane'],
    1402: ['batman', 'joker', 'harleyquinn', 'catwoman', 'robin'],
    1403: ['wonderwoman', 'hippolyta', 'amazon'],
    1404: ['greenlantern', 'guardian', 'sinestro'],
    1405: ['darkseid', 'parademon', 'desaad'],
    1406: ['highfather', 'orion', 'mistermiracle'],
    1407: ['zod', 'brainiac'],
    1408: ['adamstrange', 'sardath'],
    1409: ['hawkman', 'hawkgirl'],
    1410: ['aquaman', 'mera', 'oceanmaster'],
    1311: ['flash', 'reverseflash', 'captaincold']
  },
  randomEncounters: ['darkseid', 'sinestro', 'brainiac', 'lexluthor'],
  hostileSpecies: ['darkseid', 'parademon', 'sinestro', 'brainiac', 'zod', 'joker'],
  friendlyTraders: ['greenlantern', 'adamstrange', 'hawkman']
};

export default DCAliensPlanets;
